module.exports = __webpack_public_path__ + "static/media/services.eb8493f1.svg";